module.exports = __webpack_public_path__ + "static/img/26a.51d2140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/26a.png
// module id = OnF+
// module chunks = 0